(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-module-solo-3D"] && !Shopify.designMode) return;
  try {
    
// Ocultar el hint de rotación al primer toque/clic sobre el modelo
document.querySelectorAll('.cms-model-viewer').forEach(function(mv) {
  var hint = mv.closest('.cms-media').querySelector('.cms-rotate-hint');
  if (!hint) return;
  function hide() { hint.style.opacity = '0'; hint.style.pointerEvents = 'none'; }
  mv.addEventListener('mousedown', hide, { once: true });
  mv.addEventListener('touchstart', hide, { once: true, passive: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-stories"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.from((c || document).querySelectorAll(s)); };

  /* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
     Clase principal
  ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */
  function HeroStories(frame, wrapper) {
    this.frame    = frame;
    this.wrapper  = wrapper;
    this.slides   = $$('.hero-stories__slide', frame);
    this.bars     = $$('.hero-stories__bar',   frame);
    this.fills    = $$('.hero-stories__bar-fill', frame);
    this.prevBtn  = $('.hero-stories__nav--prev', frame);
    this.nextBtn  = $('.hero-stories__nav--next', frame);

    if (!this.slides.length) return;

    this.total    = this.slides.length;
    this.current  = 0;
    this.duration = parseInt(wrapper.dataset.slideDuration, 10) || 5000;
    this.auto     = wrapper.dataset.autoplay !== 'false';
    this.raf      = null;
    this._start   = null;
    this._elapsed = 0;
    this._paused  = false;

    this._bindEvents();
    this._goTo(0);
  }

  HeroStories.prototype._bindEvents = function () {
    var self = this;

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        self._stopCurrentVideo();
        self._next();
      });
    }
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        self._stopCurrentVideo();
        self._prev();
      });
    }

    this.frame.addEventListener('mouseenter', function () { self._pause(); });
    this.frame.addEventListener('mouseleave', function () { self._resume(); });

    document.addEventListener('visibilitychange', function () {
      document.hidden ? self._pause() : self._resume();
    });
  };

  /* ── Pausa / resume ── */
  HeroStories.prototype._pause = function () {
    this._paused = true;
    if (this._start !== null) {
      this._elapsed = Math.min(performance.now() - this._start, this.duration);
    }
    /* Pausar vídeo si el slide activo es de tipo vídeo */
    var vid = this._currentVideo();
    if (vid) {
      vid.pause();
      /* Cancelar el RAF de progreso — se relanzará en _resume */
      if (this.raf) { cancelAnimationFrame(this.raf); this.raf = null; }
    }
  };

  HeroStories.prototype._resume = function () {
    if (!this._paused) return;
    this._paused = false;
    var vid = this._currentVideo();
    if (vid) {
      vid.play().catch(function () {});
      /* Relanzar el loop de progreso del vídeo */
      var self = this;
      var idx  = this.current;
      var tickVideo = function () {
        if (self.current !== idx) return;
        var pct = vid.duration > 0
          ? Math.min((vid.currentTime / vid.duration) * 100, 100)
          : 0;
        if (self.fills[idx]) self.fills[idx].style.width = pct + '%';
        if (pct < 100) { self.raf = requestAnimationFrame(tickVideo); }
      };
      this.raf = requestAnimationFrame(tickVideo);
    } else {
      /* Foto: reanudar desde donde se pausó */
      this._start = performance.now() - this._elapsed;
    }
  };

  /* ── Helpers de vídeo ── */
  HeroStories.prototype._currentVideo = function () {
    var slide = this.slides[this.current];
    if (!slide) return null;
    if (slide.dataset.slideType !== 'video') return null;
    return slide.querySelector('.hero-stories__slide-video') || null;
  };

  HeroStories.prototype._stopCurrentVideo = function () {
    var vid = this._currentVideo();
    if (vid) {
      vid.pause();
      vid.currentTime = 0;
    }
    /* Limpiar listener ended del slide actual */
    if (this._onVideoEnded && this._vidRef) {
      this._vidRef.removeEventListener('ended', this._onVideoEnded);
      this._onVideoEnded = null;
      this._vidRef = null;
    }
  };

  /* ── Navegación ── */
  HeroStories.prototype._next = function () {
    this._goTo(this.current < this.total - 1 ? this.current + 1 : 0);
  };

  HeroStories.prototype._prev = function () {
    this._goTo(this.current > 0 ? this.current - 1 : this.total - 1);
  };

  /* ── Ir a slide ── */
  HeroStories.prototype._goTo = function (idx) {
    var self = this;
    if (this.raf) cancelAnimationFrame(this.raf);

    /* Detener vídeo del slide anterior */
    this._stopCurrentVideo();

    this.slides.forEach(function (s, i) {
      s.classList.toggle('is-active', i === idx);
    });

    this.bars.forEach(function (b, i) {
      b.classList.remove('is-done', 'is-active');
      self.fills[i].style.width = '0%';
      if (i < idx) {
        b.classList.add('is-done');
        self.fills[i].style.width = '100%';
      }
    });

    this.current  = idx;
    this._elapsed = 0;
    this._start   = null;
    this._paused  = false;

    if (!this.auto || this.total <= 1) return;

    var bar = this.bars[idx];
    if (bar) bar.classList.add('is-active');

    var vid = this._currentVideo();

    if (vid) {
      /* ── Slide de VÍDEO ── */

      /* Limpiar listener anterior si existe */
      if (this._onVideoEnded) {
        this._vidRef && this._vidRef.removeEventListener('ended', this._onVideoEnded);
      }

      vid.currentTime = 0;
      vid.play().catch(function () {});

      /* Guardar referencia para poder limpiar en _goTo siguiente */
      this._vidRef = vid;
      this._onVideoEnded = function () {
        vid.removeEventListener('ended', self._onVideoEnded);
        self._onVideoEnded = null;
        self._vidRef = null;
        /* Solo avanzar si seguimos en este slide */
        if (self.current === idx) self._next();
      };
      vid.addEventListener('ended', this._onVideoEnded);

      /* Animar la barra — guardamos el RAF en this.raf para que
         cancelAnimationFrame en el próximo _goTo lo detenga */
      var tickVideo = function () {
        if (self.current !== idx) return; /* slide ya cambió */
        var pct = vid.duration > 0
          ? Math.min((vid.currentTime / vid.duration) * 100, 100)
          : 0;
        if (self.fills[idx]) self.fills[idx].style.width = pct + '%';
        if (pct < 100) {
          self.raf = requestAnimationFrame(tickVideo);
        }
      };
      this.raf = requestAnimationFrame(tickVideo);

    } else {
      /* ── Slide de FOTO: timer estándar ── */
      this.raf = requestAnimationFrame(function (ts) { self._tick(ts); });
    }
  };

  /* ── Loop de animación (para fotos) ── */
  HeroStories.prototype._tick = function (ts) {
    var self = this;

    if (this._paused) {
      this.raf = requestAnimationFrame(function (t) { self._tick(t); });
      return;
    }

    if (this._start === null) this._start = ts - this._elapsed;
    this._elapsed = ts - this._start;

    var pct = Math.min((this._elapsed / this.duration) * 100, 100);
    if (this.fills[this.current]) this.fills[this.current].style.width = pct + '%';

    if (pct < 100) {
      this.raf = requestAnimationFrame(function (t) { self._tick(t); });
    } else {
      this._next();
    }
  };

  /* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
     Inicialización
  ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */
  function initAll() {
    $$('.hero-stories-wrapper').forEach(function (wrapper) {
      var dFrame = $('.hero-stories--desktop .hero-stories__frame', wrapper);
      if (dFrame && $('.hero-stories__slide', dFrame)) new HeroStories(dFrame, wrapper);

      var mFrame = $('.hero-stories--mobile .hero-stories__frame', wrapper);
      if (mFrame && $('.hero-stories__slide', mFrame)) new HeroStories(mFrame, wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-lunaar-system"] && !Shopify.designMode) return;
  try {
    

(function() {
  // Use section id suffix to avoid conflicts with multiple instances
  const sections = document.querySelectorAll('.lanim');

  sections.forEach(function(section) {
    const sid = section.id.replace('lanim-', '');
    const btns     = section.querySelectorAll('.lanim__btn');
    const comps    = section.querySelectorAll('.comp');
    const label    = section.querySelector('#infoLabel-' + sid);
    const count    = section.querySelector('#infoCount-' + sid);
    const progFill = section.querySelector('#progressFill-' + sid);

    const progress = {
      module:    16.6,
      connector: 33.3,
      stool:     50.0,
      bench:     66.6,
      circle:    83.3,
      custom:    100,
    };

    let currentAnim = null;

    function showComp(id) {
      if (currentAnim) { clearTimeout(currentAnim); currentAnim = null; }

      comps.forEach(function(c) {
        c.classList.remove('active', 'is-playing');
        c.querySelectorAll('.cp:not(.cp-static)').forEach(function(p) {
          p.style.opacity = '0';
        });
      });
      btns.forEach(function(b) { b.classList.remove('active'); });

      var target = section.querySelector('#comp-' + id);
      if (!target) return;
      target.classList.add('active');

      if (label) label.textContent = target.dataset.label;
      if (count) count.textContent = target.dataset.pieces;
      if (progFill) progFill.style.width = (progress[id] || 0) + '%';

      var btn = section.querySelector('.lanim__btn[data-target="' + id + '"]');
      if (btn) btn.classList.add('active');

      var paths = target.querySelectorAll('.cp');
      if (paths.length === 0) return;
      if (target.querySelectorAll('.cp-static').length > 0) return;

      var STEP  = 160;
      var PAUSE = 100;

      paths.forEach(function(p) { p.style.opacity = '0'; });

      paths.forEach(function(p, i) {
        var delay = PAUSE + i * STEP;
        currentAnim = setTimeout(function() {
          p.style.opacity = '1';
        }, delay);
      });
    }

    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        showComp(btn.dataset.target);
      });
    });

    section.addEventListener('keydown', function(e) {
      var order = ['module','connector','stool','bench','circle','custom'];
      var active = section.querySelector('.lanim__btn.active');
      if (!active) return;
      var idx = Array.from(btns).indexOf(active);
      if (e.key === 'ArrowRight' && idx < btns.length - 1) showComp(order[idx + 1]);
      if (e.key === 'ArrowLeft'  && idx > 0)               showComp(order[idx - 1]);
    });
  });
})();


  } catch(e) { console.error(e); }
})();
})();
